<script lang="ts" setup>
import { NavigationMenuLink } from 'reka-ui';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },

  description: {
    type: String,
    default: '',
  },

  href: {
    type: String,
    default: '',
  },

  to: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <NavigationMenuLink as-child>
    <a :href="props.href" class="flex gap-x-8 rounded-8 px-8 py-16 no-underline hover:bg-#F6F6F6" target="_blank" v-if="props.href">
      <div class="size-40 flex-center flex-shrink-0 border border-#EAEAF0 rounded-8px border-solid bg-white" v-if="$slots.icon">
        <slot name="icon"></slot>
      </div>
      <p class="m-0 flex flex-col gap-y-4 overflow-hidden" :class="{ 'justify-center': !props.description }">
        <strong class="truncate text-16 color-#2F2F2F font-400 leading-23">{{ props.title }}</strong>
        <span class="line-clamp-2 text-12 color-#4F4F4F font-400 leading-16" v-if="props.description">{{ props.description }}</span>
      </p>
    </a>
    <RouterLink :to="props.to" class="flex gap-x-8 rounded-8 px-8 py-16 no-underline hover:bg-#F6F6F6" v-else>
      <div class="size-40 flex-center flex-shrink-0 border border-#EAEAF0 rounded-8px border-solid bg-white" v-if="$slots.icon">
        <slot name="icon"></slot>
      </div>
      <p class="m-0 flex flex-col gap-y-4 overflow-hidden" :class="{ 'justify-center': !props.description }">
        <strong class="truncate text-16 color-#2F2F2F font-400 leading-23">{{ props.title }}</strong>
        <span class="line-clamp-2 text-12 color-#4F4F4F font-400 leading-16" v-if="props.description">{{ props.description }}</span>
      </p>
    </RouterLink>
  </NavigationMenuLink>
</template>
